import React, { useState, useEffect, Fragment } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_Response_Details, postAPI_Create_Question, putAPI_Delete_Question } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import MessageResponse from '../../components/ResponseBlock/MessageResponse';
import LinkResponse from '../../components/ResponseBlock/LinkResponse';
import ImageCarouselResponse from '../../components/ResponseBlock/ImageCarouselResponse';
import VideoResponse from '../../components/ResponseBlock/VideoResponse';
import ExampleResponse from '../../components/ResponseBlock/ExampleResponse';
import { Row, Collapse, Button } from 'reactstrap';
import QuestionOptionForm from './QuestionOptionForm';
import QuestionOption from './QuestionOption';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Validation from '../../../../../../components/Validation';
import ApiInvokeResponse from '../../components/ResponseBlock/ApiInvokeResponse';
function Question({
    propertyId,
    code,
    setId,
    loadResponse,
    QuestionId,
    Question,
    locale,
    index,
    messagesList,
    setType,
    setCollaspQuestion,
    collapseQuestion,
    quesionSetsList,
    roomTags,
    productTags,
    formList,
    isDynamicFlow = false
}) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [elem, setelem] = useState(null);
    const [isAddQuestionOption, setIsAddQuestionOption] = useState(false);

    const codeResponse = async () => {
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_Response_Details}/?property_id=${propertyId}&group_id=${getGroupID()}&code=${code}&lang=${locale === 'en' ? 'en-US' : locale}`,
        })
            .then(res => {
                setelem(res.data);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const DeleteQuestion = (id) => {
        console.log(id)
        let deleteData = {
            Deleter: 'Dashboard'
        }
        try {
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Delete_Question}/${id}`,
                data: deleteData,
            })
                .then(() => {
                    loadResponse();
                });
        } catch (error) {
            console.error(error);
        }
    }

    const SaveRecommenderQuestionCode = () => {
        let postData = {
            GroupId: getGroupID(),
            PropertyId: propertyId === "-1" ? null : propertyId,
            QuestionSetId: setId,
            Code: code,
            DisplayOrder: 1,
            Status: 'Active',
            Creator: "API"
        };

        AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_Question}`,
            data: postData,
        })
            .then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        loadResponse();
                    }, 1000)
                }
            });
    }

    useEffect(() => {
        codeResponse();
    }, [code]);

    const CancelQuestionOption = () => {
        setIsAddQuestionOption(false)
    }

    const generator = () => {

        if (elem) {
            switch (elem.response.type) {
                case 'example':
                    return (
                        <Fragment>
                            <ExampleResponse
                                elem={{ ...elem }}
                                isDynamicFlow={isDynamicFlow}
                                isRecommender={true}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                selectedLang={locale}
                                isButtonShow={true}
                            />
                        </Fragment>
                    );
                case 'invokeApi':
                    return (
                        <Fragment>
                            <ApiInvokeResponse
                                elem={{ ...elem }}
                                isRecommender={true}
                                child={1}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                                selectedLang={locale}
                                isButtonShow={true}
                                isFlowButton={true}
                            />
                        </Fragment>
                    );
                case 'messages':
                    return (
                        <Fragment>
                            <MessageResponse
                                elem={{ ...elem }}
                                child={1}
                                isDynamicFlow={isDynamicFlow}
                                isRecommender={true}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                                selectedLang={locale}
                                isButtonShow={true}
                                isFlowButton={true}
                            />
                        </Fragment>
                    );

                case 'messages-link':
                    return (
                        <Fragment>
                            <LinkResponse
                                elem={{ ...elem }}
                                child={1}
                                isRecommender={true}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                                selectedLang={locale}
                                isButtonShow={true}
                                isFlowButton={true}
                            />
                        </Fragment>
                    );

                case 'messages-image-carousel':
                    return (
                        <Fragment>
                            <ImageCarouselResponse
                                elem={{ ...elem }}
                                child={1}
                                isRecommender={true}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                                selectedLang={locale}
                                isButtonShow={true}
                                isFlowButton={true}
                            />
                        </Fragment>
                    );
                case 'messages-video':
                    return (
                        <Fragment>
                            <VideoResponse
                                elem={{ ...elem }}
                                child={1}
                                isRecommender={true}
                                SaveRecommenderQuestionCode={SaveRecommenderQuestionCode}
                                DeleteQuestion={DeleteQuestion}
                                QuestionId={QuestionId}
                                selectedLang={locale}
                                isButtonShow={true}
                                isFlowButton={true}
                            ></VideoResponse>
                        </Fragment>
                    );
                default:
                    break;
            }

        } else return null;
    };
    return (
        <Fragment>
            <div className="border question-list">
                <div className='collapse-btn'
                    onClick={() => setCollaspQuestion(index)}
                    aria-expanded={collapseQuestion === index}
                >
                    <h5 className='text-muted'>{messagesList != undefined && messagesList !== null &&
                        messagesList.length > 0 &&
                        messagesList.filter(l => l.code === code).map(elem => elem.message)}
                    </h5>
                </div>
                <Collapse isOpen={collapseQuestion === index}>
                    <Fragment>
                        {!isDynamicFlow && generator()}
                    </Fragment>
                    {(!isDynamicFlow && QuestionId !== undefined) && (
                        <Fragment>
                            <Row>
                                <Colxx xs="12" sm="2" md="2" lg="2" className="mb-4">
                                    <div
                                        onClick={() => { setIsAddQuestionOption(true); }}>
                                        <Button
                                            color="primary"
                                            className="add-button"
                                            size="xs"
                                            style={{ width: '100%' }}>
                                            <FontAwesomeIcon icon={faPlus} />
                                            <span> </span>
                                            Add Option
                                        </Button>
                                    </div>
                                </Colxx>
                            </Row>
                            <Collapse isOpen={isAddQuestionOption}>
                                <Colxx xxs="6" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                                    <QuestionOptionForm CancelQuestionOption={CancelQuestionOption} QuestionId={QuestionId}
                                        loadResponse={loadResponse}
                                        childQuestionshow={index === 0 ? false : true}
                                        messagesList={messagesList}
                                        elem={{ ...elem }}
                                        setType={setType}
                                        quesionSetsList={quesionSetsList}
                                        formList={formList}
                                        roomTags={roomTags}
                                        productTags={productTags}></QuestionOptionForm>
                                </Colxx>
                            </Collapse>
                        </Fragment>
                    )}
                    {!isDynamicFlow &&
                        <Row>
                            <Colxx xs="12" sm="6" md="6" lg="6" className="mb-4">
                                <ul style={{ listStyle: "none" }}>
                                    {Question !== undefined && Question.options !== null &&
                                        Question.options.sort((a, b) => a.displayOrder - b.displayOrder)
                                            .map((option, i) => {
                                                return (
                                                    <li key={i} className="text-muted">
                                                        <QuestionOption
                                                            option={option}
                                                            elem={{ ...elem }}
                                                            loadResponse={loadResponse}
                                                            messagesList={messagesList}
                                                            setType={setType}
                                                            childQuestionshow={index === 0 ? false : true}
                                                            quesionSetsList={quesionSetsList}
                                                            formList={formList}
                                                            roomTags={roomTags}
                                                            productTags={productTags}
                                                        />

                                                    </li>
                                                );
                                            })
                                    }
                                </ul>
                            </Colxx>
                        </Row>
                    }
                </Collapse>
            </div>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};
export default injectIntl(connect(mapStateToProps)(Question));